var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 16.6666C4.375 16.3215 4.65482 16.0416 5 16.0416L15 16.0416C15.3452 16.0416 15.625 16.3215 15.625 16.6666C15.625 17.0118 15.3452 17.2916 15 17.2916L5 17.2916C4.65482 17.2916 4.375 17.0118 4.375 16.6666Z",
    fill: "#A4A3B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55806 13.7753C9.80214 14.0193 10.1979 14.0193 10.4419 13.7753L13.3586 10.8586C13.6027 10.6145 13.6027 10.2188 13.3586 9.9747C13.1145 9.73063 12.7188 9.73063 12.4747 9.9747L10.625 11.8244V3.33331C10.625 2.98814 10.3452 2.70831 10 2.70831C9.65482 2.70831 9.375 2.98814 9.375 3.33331V11.8244L7.52527 9.9747C7.2812 9.73063 6.88547 9.73063 6.64139 9.9747C6.39731 10.2188 6.39731 10.6145 6.64139 10.8586L9.55806 13.7753Z",
    fill: "#A4A3B1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download.0e471da1db1e52c2fbefafdb6f3fe20e.svg";